var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex-center-column home-condition" }, [
      _c("div", { staticClass: "title-zh" }, [_vm._v("入驻条件")]),
      _c("div", { staticClass: "title-en" }, [_vm._v("ENTRY CONDITIONS")]),
      _c(
        "div",
        { staticClass: "flex-row-space-between-hCenter condition-list" },
        [
          _c("div", { staticClass: "flex-column-center condition-item" }, [
            _c("img", {
              attrs: { src: require("@/assets/home/condition_1.png"), alt: "" },
            }),
            _c("span", { staticClass: "dec" }, [_vm._v("登录账号状态正常")]),
            _c("span", { staticClass: "dec" }, [
              _vm._v("并且登录账号已绑定手机号"),
            ]),
          ]),
          _c("div", { staticClass: "flex-center-column condition-item" }, [
            _c("img", {
              attrs: { src: require("@/assets/home/condition_2.png"), alt: "" },
            }),
            _c("span", { staticClass: "dec" }, [
              _vm._v(
                "机构签约达人数量至少5个，并与MCN机构签署合同，达人帐号需实名认证"
              ),
            ]),
          ]),
          _c("div", { staticClass: "flex-center-column condition-item" }, [
            _c("img", {
              attrs: { src: require("@/assets/home/condition_3.png"), alt: "" },
            }),
            _c("span", { staticClass: "dec" }, [
              _vm._v(
                "MCN过往无违规行为，同一营业执照下，只允许一个MCN主体入驻"
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }